// extracted by mini-css-extract-plugin
export default {"inputsBox":"ResetPasswordForm_inputsBox__RG7eF","submitButtonBox":"ResetPasswordForm_submitButtonBox__2ooK5"};